import { HistoryLocation, globalHistory } from '@reach/router';
import { useEffect, useRef, useState } from 'react';

import { enhanceHistory } from '../utils/routeUtils';

const useHistoryLocation = (history: ReturnType<typeof enhanceHistory>): HistoryLocation | null => {
	const [previousLocation, setPreviousLocation] = useState<HistoryLocation | null>(null);
	const currentLocationRef = useRef<HistoryLocation>(globalHistory.location); // useRef to hold the current location

	useEffect(() => {
		const unsubscribe = history.listen(({ location }) => {
			if (currentLocationRef.current) {
				setPreviousLocation(currentLocationRef.current); // Set previousLocation to the last location
			}
			currentLocationRef.current = location; // Update current location
		});
		return () => {
			unsubscribe();
		};
	}, []);

	return previousLocation;
};

export default useHistoryLocation;
